import React, { useState } from "react";
import { StyledDeleteModal } from "./styles";
import { useTranslation } from "react-i18next";

const DeleteModal = (props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleOk: () => void;
  confirmLoading?: boolean;
}) => {
  const { open, setOpen, handleOk, confirmLoading } = props;
  const { t } = useTranslation();

  const [modalText, setModalText] = useState(
    t("Are you sure you want to delete?")
  );

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <StyledDeleteModal
      title={t("Delete")}
      open={open}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      centered
      okText={t("Delete")}
      cancelText={t("Cancel")}
      width={400}
    >
      <p>{modalText}</p>
    </StyledDeleteModal>
  );
};

export default DeleteModal;
